import React from 'react';
import { useHistory } from 'react-router-dom';
import StyledButton from '../../components/StyledButton';
import { useGlobalDispatch } from '../../contexts';
import AccessDenied from '../NotAllowed/AccessDenied';
import './PermissionDenied.scss';

interface IPermissionDenied{
  height?:string;
  iconWidth?:string;
  iconHeight?:string;
}
const PermissionDenied = ({ height, iconWidth, iconHeight }:IPermissionDenied) => {
  const { clearUser } = useGlobalDispatch();
  const { push } = useHistory();
  return (
    <div className="permission_cover" style={{ height }}>
      <div className="">
        <h3>Permission Denied</h3>
        <p>You do not have permission to access this resource</p>
        <StyledButton
          name="Logout"
          onClick={() => {
            clearUser();
            push('/');
          // Logout();
          }}
          width="130px"
          height="40px"
          backgroundColor="black"
          color="#fff"
          fontSize="13px"
          borderRadius="4px"
          border="1px solid #dcd8ec"
          marginLeft="16px"
        />
      </div>
      <div className="">
        <AccessDenied width={iconWidth || '250px'} height={iconHeight || '250px'} />
      </div>
    </div>
  );
};
export default PermissionDenied;
